<template>
  <div>
    <DarkModeSwitcher />
    <div class="container">
      <div class="error-page flex flex-col items-center justify-center h-screen text-center">
        <div class="text-white">
          <div class="intro-x text-8xl font-medium">403</div>
          <div class="intro-x text-xl lg:text-3xl font-medium mt-5">
            Unauthorized access
          </div>
          <div class="intro-x text-lg mt-3">
            You do not have permission to view this page.
          </div>
          <button class="intro-x btn py-3 px-4 text-white border-white dark:border-dark-5 dark:text-gray-300 mt-10" @click="submit_form">
            Back to Home
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed,defineComponent, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import DarkModeSwitcher from '@/components/dark-mode-switcher/Main.vue'
import {
    useStore
} from '@/store'
export default defineComponent({
  components: {
    DarkModeSwitcher
  },
  setup() {
    const router = useRouter()
    const store = useStore()
    const userDetails = computed(() => store.state.user.currentUser)
    onMounted(() => {
      cash('body')
        .removeClass('main')
        .removeClass('login')
        .addClass('error-page')
    })
    const submit_form = () => {
      const role = Number(userDetails.value?.user_role);
      if (role == 1) {
            router.push('/')
          } else if (role == 2 || role == 8) {
            router.push({ name: 'manager-dashboard' })
          } else if (role == 3) {
            router.push({ name: 'party-dashboard' })
          } else if (role == 4) {
            router.push({ name: 'jober-dashboard' })
          } else if (role == 5) {
            router.push({ name: 'planner-dashboard' })
          } else if (role == 6) {
            router.push({ name: 'checker-dashboard' })
          } else{
            router.push('/')
          }
    }

    return {
      submit_form
    }
  }
})
</script>
